<template>
	<!-- 空模板，因为我们使用动态创建的DOM元素 -->
	<div></div>
</template>

<script>
export default {
	name: "rightMenu",
	data() {
		return {
			show: false,
			pos: {
				x: 0,
				y: 0,
			},
			items: [],
			// 存储DOM元素引用
			domElement: null
		}
	},
	mounted() {
		// 创建DOM元素并添加到body
		this.createDomElement();
	},
	destroyed() {
		// 清理DOM元素
		this.removeDomElement();
	},
	watch: {
		// 监听show属性变化，控制DOM元素的显示/隐藏
		show(newVal) {
			if (this.domElement) {
				this.domElement.style.display = newVal ? 'block' : 'none';
			}
		},
		// 监听pos和items变化，更新DOM元素
		pos: {
			handler() {
				this.updateDomElement();
			},
			deep: true
		},
		items() {
			this.updateDomElement();
		}
	},
	methods: {
		open(pos, items) {
			// 检查pos是否为鼠标事件对象
			if (pos && typeof pos === 'object') {
				// 优先使用pageX和pageY，这样即使有滚动条也能正确定位
				if ('pageX' in pos && 'pageY' in pos) {
					this.pos.x = pos.pageX;
					this.pos.y = pos.pageY;
				} else if ('clientX' in pos && 'clientY' in pos) {
					// 后备方案：使用clientX和clientY
					this.pos.x = pos.clientX;
					this.pos.y = pos.clientY;
				} else {
					// 如果是普通对象，直接使用x和y属性
					this.pos.x = pos.x;
					this.pos.y = pos.y;
				}
			} else {
				// 如果pos不是对象，使用默认位置
				this.pos.x = 0;
				this.pos.y = 0;
			}
			this.items = items;
			this.show = true;
			this.rejustPos();
		},
		close() {
			this.show = false;
		},
		onSelectMenu(item) {
			this.$emit("select", item);
			this.close();
		},
		rejustPos() {
			// 使用更准确的菜单项高度计算
			let menuItemHeight = 32; // 菜单项内容高度
			let menuItemPadding = 8; // 上下padding各8px
			let menuH = this.items.length * (menuItemHeight + menuItemPadding * 2) + 16; // 增加容器内边距
			let menuW = 120; // 使用样式中定义的最小宽度
			
			// 获取视口大小
			let viewportWidth = window.innerWidth;
			let viewportHeight = window.innerHeight;
			
			// 确保菜单不会超出视口范围
			if (this.pos.y > viewportHeight - menuH) {
				this.pos.y = viewportHeight - menuH;
			}
			if (this.pos.x > viewportWidth - menuW) {
				this.pos.x = viewportWidth - menuW;
			}
			
			// 确保菜单位置不会为负数
			this.pos.x = Math.max(0, this.pos.x);
			this.pos.y = Math.max(0, this.pos.y);
		},
		// 创建DOM元素并添加到body
		createDomElement() {
			// 创建遮罩层
			let mask = document.createElement('div');
			mask.className = 'right-menu-mask';
			mask.style.display = 'none';
			mask.addEventListener('click', this.close.bind(this));
			mask.addEventListener('contextmenu', (e) => {
				e.preventDefault();
				this.close();
			});
			
			// 创建菜单容器
			let menu = document.createElement('div');
			menu.className = 'right-menu';
			
			// 创建菜单内容容器
			let menuContainer = document.createElement('div');
			menuContainer.className = 'menu-container';
			
			// 组合元素
			menu.appendChild(menuContainer);
			mask.appendChild(menu);
			
			// 添加到body
			document.body.appendChild(mask);
			
			// 存储引用
			this.domElement = mask;
			this.menuElement = menu;
			this.menuContainerElement = menuContainer;
		},
		// 移除DOM元素
		removeDomElement() {
			if (this.domElement && this.domElement.parentNode === document.body) {
				document.body.removeChild(this.domElement);
				this.domElement = null;
				this.menuElement = null;
				this.menuContainerElement = null;
			}
		},
		// 更新DOM元素
		updateDomElement() {
			if (!this.domElement || !this.menuElement || !this.menuContainerElement) {
				return;
			}
			
			// 更新菜单位置
			if (this.menuElement) {
				this.menuElement.style.left = this.pos.x + 'px';
				this.menuElement.style.top = this.pos.y + 'px';
			}
			
			// 更新菜单项
			if (this.menuContainerElement) {
				// 清空现有内容
				this.menuContainerElement.innerHTML = '';
				
				// 添加新菜单项
				this.items.forEach(item => {
					let menuItem = document.createElement('div');
					menuItem.className = 'menu-item' + (item.danger ? ' danger' : '');
					menuItem.addEventListener('click', (e) => {
						e.stopPropagation();
						this.onSelectMenu(item);
					});
					
					// 添加图标
					if (item.icon) {
						let icon = document.createElement('i');
						icon.className = 'menu-icon ' + item.icon;
						menuItem.appendChild(icon);
					}
					
					// 添加文本
					let text = document.createElement('span');
					text.className = 'menu-text';
					text.textContent = item.name;
					menuItem.appendChild(text);
					
					// 添加到容器
					this.menuContainerElement.appendChild(menuItem);
				});
			}
		}
	}
}
</script>

<style lang="scss">
.right-menu-mask {
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	z-index: 9999;
}

.right-menu {
	position: fixed;
	border-radius: 12px;
	overflow: hidden;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
	background: rgba(255, 255, 255, 0.95);
	backdrop-filter: blur(20px);
	border: 1px solid rgba(255, 255, 255, 0.2);
	z-index: 10000;

	.menu-container {
		padding: 8px 0;
		min-width: 120px;

		.menu-item {
			display: flex;
			align-items: center;
			padding: 8px 16px;
			cursor: pointer;
			transition: all 0.2s ease;
			position: relative;
			font-size: 14px;
			color: var(--im-text-color);

			&:hover {
				background: var(--im-background-active);
				color: var(--im-color-primary);
			}

			&.danger {
				color: var(--im-color-danger);

				&:hover {
					background: rgba(245, 108, 108, 0.1);
					color: var(--im-color-danger);
				}

				&:active {
					background: rgba(245, 108, 108, 0.2);
					transform: scale(0.98);
				}
			}

			.menu-icon {
				font-size: 16px;
				margin-right: 8px;
				width: 16px;
				text-align: center;
			}

			.menu-text {
				flex: 1;
				font-weight: 500;
			}
		}
	}
}
</style>
